// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Page ─────────────────────────────────────────────────────────────────── */
.ers-page {
    padding: 0;
    padding-block-start: 50px;
    background: transparent;
    min-height: 100%;
}

.ers-main-title {
    margin: 0 0 16px 0;
    font-size: 1.30rem;
    font-weight: 700;
    color: #111827;
    padding-left: 18px;
}

/* ─── Loading / Empty ──────────────────────────────────────────────────────── */
.ers-loading {
    padding: 40px 0;
    text-align: center;
    color: #6b7280;
    font-size: 0.9rem;
}

.ers-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 50px 20px;
    color: #9ca3af;
}

.ers-empty-icon {
    font-size: 2rem;
}

.ers-empty-text {
    font-size: 0.9rem;
}

/* ─── Cards grid ───────────────────────────────────────────────────────────── */
.ers-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 16px;
    padding: 4px 0;
}

/* ─── Card ─────────────────────────────────────────────────────────────────── */
.ers-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.ers-card-header {
    padding: 10px 14px;
    background: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ers-card-title {
    font-size: 0.82rem;
    font-weight: 700;
    color: #374151;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.ers-card-body {
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* ─── Row / Label / Value ──────────────────────────────────────────────────── */
.ers-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.ers-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    min-width: 52px;
    padding-top: 2px;
    flex-shrink: 0;
}

.ers-value {
    font-size: 0.82rem;
    color: #111827;
}

/* ─── Chips ────────────────────────────────────────────────────────────────── */
.ers-chip-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.ers-chip {
    display: inline-flex;
    align-items: center;
    background: #f3f4f6;
    color: #374151;
    border-radius: 999px;
    padding: 2px 9px;
    font-size: 0.73rem;
    font-weight: 500;
    border: 1px solid #e5e7eb;
}

.ers-chip-format {
    background: #fff7ed;
    color: #92400e;
    border-color: #fde68a;
    font-weight: 700;
    letter-spacing: 0.04em;
}

/* ─── Reports section ──────────────────────────────────────────────────────── */
.ers-reports {
    margin-top: 4px;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.ers-reports-title {
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #9ca3af;
    margin-bottom: 2px;
}

.ers-report-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.ers-report-name {
    font-size: 0.78rem;
    color: #374151;
    min-width: 120px;
    flex-shrink: 0;
}

/* ─── Error ────────────────────────────────────────────────────────────────── */
.ers-error {
    padding: 20px;
    text-align: center;
    color: #dc2626;
    font-size: 0.85rem;
}

/* ─── Job section wrapper ──────────────────────────────────────────────────── */
.ers-job-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* ─── Status bar ───────────────────────────────────────────────────────────── */
.ers-status-bar {
    display: flex;
    gap: 0;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    overflow: hidden;
}

.ers-status-item {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    padding: 14px 10px;
    border-right: 1px solid #e5e7eb;
}

.ers-status-item:last-child {
    border-right: none;
}

.ers-status-count {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
}

.ers-status-label {
    font-size: 0.68rem;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 600;
}

.ers-status-waiting   { color: #6b7280; }
.ers-status-active    { color: #059669; }
.ers-status-delayed   { color: #d97706; }
.ers-status-completed { color: #2563eb; }
.ers-status-failed    { color: #dc2626; }

/* ─── Triggers table ───────────────────────────────────────────────────────── */
.ers-table-wrapper {
    overflow-x: auto;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
}

.ers-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.82rem;
}

.ers-table thead th {
    background: #f9fafb;
    padding: 10px 14px;
    text-align: left;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #6b7280;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
}

.ers-table tbody td {
    padding: 10px 14px;
    border-bottom: 1px solid #f3f4f6;
    color: #374151;
    vertical-align: middle;
    white-space: nowrap;
}

.ers-table tbody tr:last-child td {
    border-bottom: none;
}

.ers-table tbody tr:hover td {
    background: #fafafa;
}

.ers-td-no {
    color: #9ca3af;
    font-size: 0.75rem;
    width: 36px;
}

.ers-td-id {
    font-family: monospace;
    font-size: 0.78rem;
    color: #6b7280;
}

.ers-td-fail {
    color: #dc2626;
    font-size: 0.78rem;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ers-td-time {
    font-size: 0.78rem;
    color: #6b7280;
    white-space: nowrap;
}

.ers-td-center {
    text-align: center;
}

.ers-td-reports {
    font-size: 0.78rem;
    color: #374151;
}

/* ─── Status badge ─────────────────────────────────────────────────────────── */
.ers-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 9px;
    border-radius: 999px;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: capitalize;
}

.ers-badge-waiting   { background: #f3f4f6; color: #6b7280; }
.ers-badge-active    { background: #d1fae5; color: #065f46; }
.ers-badge-delayed   { background: #fef3c7; color: #92400e; }
.ers-badge-completed { background: #dbeafe; color: #1e40af; }
.ers-badge-failed    { background: #fee2e2; color: #991b1b; }

/* ─── Custom schedule block ────────────────────────────────────────────────── */
.ers-custom-block {
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    padding: 8px 10px;
    background: #f9fafb;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.ers-custom-header {
    margin-bottom: 4px;
}

.ers-custom-label {
    font-size: 0.8rem;
    font-weight: 700;
    color: #1f2937;
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/ErpReportSchedules/erpreportschedule.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;IACI,UAAU;IACV,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,iFAAiF;AACjF;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,cAAc;AAClB;;AAEA,iFAAiF;AACjF;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,iFAAiF;AACjF;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,MAAM;IACN,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;;AAExC,iFAAiF;AACjF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;IACd,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,iFAAiF;AACjF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D,iFAAiF;AACjF;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":["/* ─── Page ─────────────────────────────────────────────────────────────────── */\n.ers-page {\n    padding: 0;\n    padding-block-start: 50px;\n    background: transparent;\n    min-height: 100%;\n}\n\n.ers-main-title {\n    margin: 0 0 16px 0;\n    font-size: 1.30rem;\n    font-weight: 700;\n    color: #111827;\n    padding-left: 18px;\n}\n\n/* ─── Loading / Empty ──────────────────────────────────────────────────────── */\n.ers-loading {\n    padding: 40px 0;\n    text-align: center;\n    color: #6b7280;\n    font-size: 0.9rem;\n}\n\n.ers-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 50px 20px;\n    color: #9ca3af;\n}\n\n.ers-empty-icon {\n    font-size: 2rem;\n}\n\n.ers-empty-text {\n    font-size: 0.9rem;\n}\n\n/* ─── Cards grid ───────────────────────────────────────────────────────────── */\n.ers-cards-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n    gap: 16px;\n    padding: 4px 0;\n}\n\n/* ─── Card ─────────────────────────────────────────────────────────────────── */\n.ers-card {\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n.ers-card-header {\n    padding: 10px 14px;\n    background: #f9fafb;\n    border-bottom: 1px solid #e5e7eb;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.ers-card-title {\n    font-size: 0.82rem;\n    font-weight: 700;\n    color: #374151;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n}\n\n.ers-card-body {\n    padding: 12px 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n/* ─── Row / Label / Value ──────────────────────────────────────────────────── */\n.ers-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n}\n\n.ers-label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #6b7280;\n    min-width: 52px;\n    padding-top: 2px;\n    flex-shrink: 0;\n}\n\n.ers-value {\n    font-size: 0.82rem;\n    color: #111827;\n}\n\n/* ─── Chips ────────────────────────────────────────────────────────────────── */\n.ers-chip-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n}\n\n.ers-chip {\n    display: inline-flex;\n    align-items: center;\n    background: #f3f4f6;\n    color: #374151;\n    border-radius: 999px;\n    padding: 2px 9px;\n    font-size: 0.73rem;\n    font-weight: 500;\n    border: 1px solid #e5e7eb;\n}\n\n.ers-chip-format {\n    background: #fff7ed;\n    color: #92400e;\n    border-color: #fde68a;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n}\n\n/* ─── Reports section ──────────────────────────────────────────────────────── */\n.ers-reports {\n    margin-top: 4px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.ers-reports-title {\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #9ca3af;\n    margin-bottom: 2px;\n}\n\n.ers-report-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.ers-report-name {\n    font-size: 0.78rem;\n    color: #374151;\n    min-width: 120px;\n    flex-shrink: 0;\n}\n\n/* ─── Error ────────────────────────────────────────────────────────────────── */\n.ers-error {\n    padding: 20px;\n    text-align: center;\n    color: #dc2626;\n    font-size: 0.85rem;\n}\n\n/* ─── Job section wrapper ──────────────────────────────────────────────────── */\n.ers-job-section {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n/* ─── Status bar ───────────────────────────────────────────────────────────── */\n.ers-status-bar {\n    display: flex;\n    gap: 0;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.ers-status-item {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 3px;\n    padding: 14px 10px;\n    border-right: 1px solid #e5e7eb;\n}\n\n.ers-status-item:last-child {\n    border-right: none;\n}\n\n.ers-status-count {\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1;\n}\n\n.ers-status-label {\n    font-size: 0.68rem;\n    color: #9ca3af;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    font-weight: 600;\n}\n\n.ers-status-waiting   { color: #6b7280; }\n.ers-status-active    { color: #059669; }\n.ers-status-delayed   { color: #d97706; }\n.ers-status-completed { color: #2563eb; }\n.ers-status-failed    { color: #dc2626; }\n\n/* ─── Triggers table ───────────────────────────────────────────────────────── */\n.ers-table-wrapper {\n    overflow-x: auto;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n}\n\n.ers-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.82rem;\n}\n\n.ers-table thead th {\n    background: #f9fafb;\n    padding: 10px 14px;\n    text-align: left;\n    font-size: 0.7rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #6b7280;\n    border-bottom: 1px solid #e5e7eb;\n    white-space: nowrap;\n}\n\n.ers-table tbody td {\n    padding: 10px 14px;\n    border-bottom: 1px solid #f3f4f6;\n    color: #374151;\n    vertical-align: middle;\n    white-space: nowrap;\n}\n\n.ers-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.ers-table tbody tr:hover td {\n    background: #fafafa;\n}\n\n.ers-td-no {\n    color: #9ca3af;\n    font-size: 0.75rem;\n    width: 36px;\n}\n\n.ers-td-id {\n    font-family: monospace;\n    font-size: 0.78rem;\n    color: #6b7280;\n}\n\n.ers-td-fail {\n    color: #dc2626;\n    font-size: 0.78rem;\n    max-width: 180px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.ers-td-time {\n    font-size: 0.78rem;\n    color: #6b7280;\n    white-space: nowrap;\n}\n\n.ers-td-center {\n    text-align: center;\n}\n\n.ers-td-reports {\n    font-size: 0.78rem;\n    color: #374151;\n}\n\n/* ─── Status badge ─────────────────────────────────────────────────────────── */\n.ers-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 9px;\n    border-radius: 999px;\n    font-size: 0.72rem;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n.ers-badge-waiting   { background: #f3f4f6; color: #6b7280; }\n.ers-badge-active    { background: #d1fae5; color: #065f46; }\n.ers-badge-delayed   { background: #fef3c7; color: #92400e; }\n.ers-badge-completed { background: #dbeafe; color: #1e40af; }\n.ers-badge-failed    { background: #fee2e2; color: #991b1b; }\n\n/* ─── Custom schedule block ────────────────────────────────────────────────── */\n.ers-custom-block {\n    border: 1px solid #e5e7eb;\n    border-radius: 7px;\n    padding: 8px 10px;\n    background: #f9fafb;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.ers-custom-header {\n    margin-bottom: 4px;\n}\n\n.ers-custom-label {\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: #1f2937;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
